import {FileTextIcon} from 'shells/icon/svg/file-text-icon';
// @ts-expect-error - imported from .js/.jsx file
import {SiteGlobeIcon} from 'shells/icon/svg/site-globe-icon';

import type {GetContextDocuments_contextDocuments as ContextDocument} from 'nutshell-graphql-types';

export const getPrimaryText = (cell: {value: ContextDocument}): string => {
    switch (cell.value.sourceType) {
        case 'WEB_PAGE':
            return cell.value.url ? cell.value.url.fullyQualifiedUrl : '';
        case 'PDF':
            return cell.value.name || '';
        default:
            return '';
    }
};

export const getIcon = (cell: {value: ContextDocument}): React.ReactElement<any> => {
    switch (cell.value.sourceType) {
        case 'WEB_PAGE':
            return SiteGlobeIcon;
        case 'PDF':
            // @ts-expect-error
            return FileTextIcon;
        default:
            return SiteGlobeIcon;
    }
};
